var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.innerTo != null)?_c('router-link',{attrs:{"to":_vm.innerTo,"target":_vm.innerTarget}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }